import info from "./info.json";

const config = {};

config.DEV = {
  backendUrl: "https://api.treasury-staging.todaq.net",
  twinBizDomain: "biz-staging.todaq.net",
  authClientId: "toda:dev:treasury"
};


config.PROD = {
  backendUrl: "https://api.treasury.todaq.net",
  twinBizDomain: "biz.todaq.net",
  authClientId: "toda:app:treasury"
};

config.STAGING = {
  backendUrl: "https://api.treasury-staging.todaq.net",
  twinBizDomain: "biz-staging.todaq.net",
  authClientId: "toda:staging:treasury"
};

export default config[info.env];
